import { useMemo, type ReactNode } from 'react';
import { createTmdbClient } from '@physical-movies/core';
import { TmdbContext } from './context';

export function TmdbProvider({ children }: { children: ReactNode }) {
  const client = useMemo(
    () => createTmdbClient({ readToken: import.meta.env.VITE_TMDB_READ_TOKEN ?? '' }),
    [],
  );

  return <TmdbContext value={client}>{children}</TmdbContext>;
}
